/* eslint-disable */
// @ts-nocheck
import * as QueryString from 'query-string';
import debugLib from 'debug';
import { GENERAL_COMMUNICATON_TOPICS } from '@branchjs/communicator';

import { fetchAppsAndOrgs, fetchCurrentOrg } from '../../common/actions/OrgActions';
import { fetchCurrentApp } from '../../common/actions/AppActions';
import { loadRole, loadUser } from '../../common/actions/UserActions';
import { getUserOnboardingData } from '../../common/actions/UserOnboardingDataActions';
import { getDefaultRoles, getUserPermissions } from '../actions/AccessControlActions';
import { getSSO } from '../actions/SsoActions';
import { getBookmarkedReports, mountFromLinkData, mountFromLocalStorage } from '../../common/actions/ShareableActions';
import { hydrate } from '../actions/FlipperActions';
import { GetExportWhitelist, GetMau, GetMonthToDateMau, GetSubscriptions } from '../actions/SubscriptionActions';
import { loadThirdPartyProviderConfig } from '../actions/ThirdPartyProviderConfigActions';
import { loadThirdPartyGlobalSettings } from '../actions/ThirdPartyGlobalSettingsActions';
import { getEmailProviderBlueprint } from '../actions/EmailOnboarding/EmailProviderBlueprint';
import { loadSDKInfo, loadSDKLatestInfo } from '../actions/SDKInfoActions';
import { getCustomDruidEvents } from '../../common/actions/DruidActions';
import { getCustomCalculations } from '../actions/CustomCalculation/CustomCalculationActions';
import AnalyticsActions from '../actions/AnalyticsActions.jsx';
import { getAlerts } from '../actions/AlertNotificationsActions';

import { fetchEventsPopularity } from '../actions/Events/EventsActions';
import { getUserAppTerms } from '../../common/actions/UserEntityTermsActions';

import dash_api from '../support/dash_api';
import { takeLeading } from '../support/utils';
import { getRangeInTimezoneEndingNow } from '../support/dateUtils';
import { AGENCY_VIEW, APP_VIEW, ORG_VIEW } from '../../common/support/viewConstants';
import { MicroFrontendContextPayloadProvider } from './MicroFrontendContextPayloadProvider';
import { getMicroFrontendsConfig, getMicroFrontendVersions } from '../actions/MicroFrontendActions';
import { fetchAppStatus } from '../actions/StatusActions';
import { fetchAppCategory } from '../actions/AppCategoryActions';
import { fetchMauLimit, fetchMauOverageCost, fetchMauCountData } from '../actions/Usage/mau/MauUsageActions';
import { fetchLinkCreationBlockedStatus } from '../actions/FraudFighterActions';

const debug = debugLib('MainApp');
const { ACCESS_TOKEN, CONTEXT, DASH_INIT, REFRESH_TOKEN } = GENERAL_COMMUNICATON_TOPICS;

const STAGE = 'stage.branch.io';
const isStage = () => window.location.origin.indexOf(STAGE) >= 0;

export const initAccessControlWithAgencyUsers = (store: any, settings: { view: { current_view: string } }) => {
  store.dispatch(loadUser()).then((state) => {
    store.dispatch(getUserPermissions(state.agency_user, settings.view.current_view === AGENCY_VIEW));
  });
  store.dispatch(getDefaultRoles());
  store.dispatch(loadRole());
};

const initBillingScreen = (store: any, current_view: string) => {
  if (current_view === APP_VIEW) {
    store.dispatch(GetSubscriptions.request());
    store.dispatch(GetMau.request());
    store.dispatch(GetMonthToDateMau.request());
    store.dispatch(GetExportWhitelist.request());
  } else if (current_view === ORG_VIEW) {
    store.dispatch(GetSubscriptions.request());
    store.dispatch(GetMau.request());
    store.dispatch(GetMonthToDateMau.request());
  }
};

export const initMicroFrontendContext = (communicator) => {
  const microFrontendInitSubscription = communicator.on(DASH_INIT, () => {
    const payload = new MicroFrontendContextPayloadProvider({
      env: window.App?.context?.environment,
      view: window.App?.context?.view,
      origin: window.location?.origin,
      pendo: window?.App?.context?.pendoId,
      nonSSODashboardUrl: isStage() ? window.location.origin : window.API_BASE || window.location.origin,
      codeVersion: window?.App?.context?.codeVersion,
      sentry: {
        sentryEveryRequest: window?.App?.context?.flipper?.sentry_every_request,
        tracesSampleRate: window?.App?.context?.tracesSampleRate,
        errorSampleRate: window?.App?.context?.errorSampleRate,
        alertNotificationsId: window?.App?.context?.sentryAlertNotificationsId,
        journeysCreativesOptimizationId: window?.App?.context?.sentryJourneysCreativesOptimizationId,
        postbacksFormId: window?.App?.context?.sentryPostbacksFormId,
        qrCodeCustomizationsId: window?.App?.context?.sentryQrCodeCustomizationsId,
        quickLinkTemplatesId: window?.App?.context?.sentryQuickLinkTemplatesId,
        usageId: window?.App?.context?.sentryUsageId,
        discoDashboardId: window?.App?.context?.sentryDiscoDashboardId,
      },
      userId: window?.App?.context?.userId,
    }).getPayload();

    communicator.send(CONTEXT, payload);
  });
  return microFrontendInitSubscription;
};

export const initMicroFrontendAuthentication = (communicator) => {
  const microFrontendInitSubscription = communicator.on(DASH_INIT, async () => {
    try {
      const { data: accessToken } = await dash_api.get('/v1/authentication/access-token');
      communicator.send(ACCESS_TOKEN, { accessToken });
    } catch (error) {
      console.error(error);
      console.error('Unable to fetch access token');
    }
  });
  return microFrontendInitSubscription;
};

export const initMicroFrontendRefreshAuthentication = (communicator) => {
  const takeLeadingGetAccessToken = takeLeading(() => dash_api.get('/v1/authentication/access-token'));
  const microFrontendRefreshAuthSubscription = communicator.on(REFRESH_TOKEN, async () => {
    try {
      const res = await takeLeadingGetAccessToken();
      if (!res) {
        return;
      }
      const { data: accessToken } = res;
      communicator.send(ACCESS_TOKEN, { accessToken });
    } catch (error) {
      console.error(error);
      console.error('Unable to fetch access token');
    }
  });
  return microFrontendRefreshAuthSubscription;
};

export const ignite = (
  store: any,
  settings: {
    view: { current_view: string };
    flipper: { custom_calculations: boolean; alert_notifications: boolean };
  }
) => {
  store.dispatch(getMicroFrontendVersions());
  store.dispatch(getMicroFrontendsConfig());
  store.dispatch(fetchAppsAndOrgs());
  store.dispatch(fetchCurrentOrg());
  store.dispatch(fetchAppCategory());

  initAccessControlWithAgencyUsers(store, settings);

  store.dispatch(getSSO());

  store.dispatch(mountFromLocalStorage());
  store.dispatch(getBookmarkedReports());
  store.dispatch(hydrate());

  if (settings.view.current_view === APP_VIEW) {
    store.dispatch(fetchCurrentApp());
    store.dispatch(loadThirdPartyGlobalSettings());
    store.dispatch(loadThirdPartyProviderConfig());
    store.dispatch(getEmailProviderBlueprint());
    store.dispatch(loadSDKInfo());
    store.dispatch(loadSDKLatestInfo());
    store.dispatch(getCustomDruidEvents());
    store.dispatch(getUserAppTerms());
    store.dispatch(fetchEventsPopularity());
    store.dispatch(fetchAppStatus());
    store.dispatch(fetchLinkCreationBlockedStatus());
    store.dispatch(fetchMauLimit());
    store.dispatch(fetchMauOverageCost());
    store.dispatch(fetchMauCountData());
    if (settings.flipper.alert_notifications) {
      store.dispatch(getAlerts());
    }
    if (settings.flipper.custom_calculations) {
      store.dispatch(getCustomCalculations());
    }
  }
  initBillingScreen(store, settings.view.current_view);
  store.dispatch(getUserOnboardingData());
};

export const initDefaultAccessControl = (store) => {
  store.dispatch(loadRole());
  store.dispatch(loadUser());
  store.dispatch(getUserPermissions());
  store.dispatch(getDefaultRoles());
};

export const initAnalyticActions = () => {
  const query = QueryString.parse(location.search);
  if (query.date_range) {
    const date_range = getRangeInTimezoneEndingNow(parseInt(query.date_range));

    AnalyticsActions.setDate(...Object.values(date_range));
  }
};

export const initBranch = (tracking_disabled, store) => {
  window.branch.init('key_live_jpc4Hi6KhTtrwVHvdvMAQpokDxpB4Poc', { tracking_disabled }, (err, res) => {
    if (err) {
      debug('branchSDK.init: error', err);
      return;
    }
    if (res.data_parsed) {
      if (res.data_parsed.shareablePageState) {
        debug('branchSDK.init: shareableLinkData', res.data_parsed.shareablePageState);
        store.dispatch(mountFromLinkData(res.data_parsed.shareablePageState));
      }
    }
  });
};
